import { Component } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PersonaService } from 'src/app/services/persona.service';
import { LoadingService } from 'src/app/services/shared/loading.service';
import { ToastService } from 'src/app/services/toast.service';
import { checkForValidationErrors } from 'src/app/utils/checkForValidationErrors';
import { PersonaExistsInfoComponent } from './persona-exists-info/persona-exists-info.component';

@Component({
  selector: 'apc-create-persona',
  templateUrl: './create-persona.component.html',
  styleUrls: ['./create-persona.component.scss'],
})
export class CreatePersonaComponent {
  public form: UntypedFormGroup;
  public isSaved: boolean = false;
  public existingPersonaModalRef: any;
  public numberOfExistingModals: number = 0;

  constructor(
    private modalService: NgbModal,
    private personaService: PersonaService,
    private toastService: ToastService,
    private loadingService: LoadingService,
    private router: Router
  ) {
    this.initSingleForm();
  }

  initSingleForm() {
    this.form = new UntypedFormGroup({
      firstName: new UntypedFormControl(null, [Validators.required]),
      firstSurname: new UntypedFormControl(null, [Validators.required]),
      link: new UntypedFormControl({value: null, disabled: true}),
    });
  }

  open(content) {
    this.form.reset();
    this.isSaved = false;
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then(
      (result) => {},
      (reason) => {
        this.initSingleForm();
      }
    );
  }

  close() {
    this.initSingleForm();
    this.modalService.dismissAll();
  }

  async checkAndCreatePersona(e) {
    this.loadingService.pushLoadingRequests('any');
    this.personaService
      .checkIfPersonaExists(this.form.controls.firstName.value + ' ' + this.form.controls.firstSurname.value)
      .subscribe((res: any) => {
        this.loadingService.popLoadingRequests();
        if (res.length > 0) {
          const existingPersonaModalRef = this.modalService.open(PersonaExistsInfoComponent, {
            ariaLabelledBy: 'modal-persona-exists',
            size: 'lg',
            backdropClass: 'existingPersonaBackdrop',
          });
          existingPersonaModalRef.componentInstance.personas = res;
          existingPersonaModalRef.componentInstance.currentPersona =
            this.form.controls.firstName.value + ' ' + this.form.controls.firstSurname.value;
          existingPersonaModalRef.result.then(
            (result) => {
              if (result) {
                this.loadingService.pushLoadingRequests('any');
                this.saveSinglePerson();
              }
            }
          );
        } else {
          this.saveSinglePerson();
        }
      });
  }

  async saveSinglePerson() {
    this.personaService
      .createPersona(this.form.value)
      .then((response: any) => {
        this.isSaved = true;
        this.close();
        this.router.navigate(['persona/' + response.identifier])
        this.toastService.showSuccess(response.fullName + ' created successfully!'
        );
        this.loadingService.popLoadingRequests();
      })
      .catch((error) => {
        checkForValidationErrors(error, this.form);
        this.loadingService.popLoadingRequests();
      });
  }

  clearAll() {
    this.isSaved = false;
    this.initSingleForm();
  }
}
